import React from 'react';
import { exportLocationsToJson } from '../../../../Services';
import { resetSetupData } from '../utils/setupOperations';
import '../../../styles/modes/setupMode.css';

/**
 * Setup Actions component for handling file export and reset
 */
const SetupActions = ({ 
  locations, 
  setLocations, 
  setStartId, 
  setPath, 
  currentModeRef,
  isSetupMode 
}) => {
  // Reset all data (location points and path)
  const handleReset = () => {
    resetSetupData(setLocations, setStartId, setPath, currentModeRef, isSetupMode);
  };

  if (locations.length === 0) {
    return null;
  }

  return (
    <div className="setup-actions">
      <button 
        className="download-points-btn"
        onClick={() => exportLocationsToJson(locations)}
      >
        Download Points
      </button>
      <button 
        className="reset-btn"
        onClick={handleReset}
      >
        Reset All
      </button>
    </div>
  );
};

export default SetupActions; 